import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { replace } from '../../../utils/func';
import { Decimal } from 'decimal.js';
import {
  addProductToCartOperation,
  changeLocalCartOperation,
  decreaseCartProductQuantityOperation,
  deleteProductFromCartOperation,
} from '../../../store/cart/operations';
import { saveModalOrderAction } from '../../../store/modal/actions';
import styles from './CartItem.module.scss';
import { AuthContext } from '../../../context/AuthContext';
import defaultImg from '../../../theme/assets/images/pexels-rethaferguson-3059609.jpg';
import { getBottleCountAndPrice } from '../../../utils/bottlePrice';
import { isDiscountValid } from '../../../utils/discountHelper';
import PriceBlock from '../../PriceBlock/PriceBlock';

const CartItem = ({ product, cartQuantity, cart, disableDel, bottleCost }) => {
  const { previousPrice, currentPrice, quantity, _id: id, bottling, quantityMl } = product;
  const { isAuthenticated, permissions } = useContext(AuthContext);
  const isAuth = isAuthenticated;
  const admin = permissions?.admin?.access;
  const dispatch = useDispatch();
  const [controlQuantity, setControlQuantity] = useState(cartQuantity);
  const [clickDisabled, setClickDisabled] = useState(false);

  const maxQuantity = bottling ? quantityMl : quantity;

  const updateQuantityInCart = newQty => {
    setControlQuantity(newQty);

    if (bottling) {
      // розпив: перераховуємо пляшечки та оновлюємо item в корзині
      const newBottleCost = getBottleCountAndPrice(newQty);

      dispatch(
        changeLocalCartOperation(id, 'updateBottling', {
          cartQuantity: newQty,
          bottleCost: newBottleCost,
        }),
      );
    } else {
      // звичайний товар — стара логіка
      if (newQty > cartQuantity) {
        dispatch(changeLocalCartOperation(id, 'add'));
        // if (isAuth) {
        //   dispatch(addProductToCartOperation(admin, id));
        // }
      } else if (newQty < cartQuantity) {
        dispatch(changeLocalCartOperation(id, 'decrease'));
        // if (isAuth) {
        //   dispatch(decreaseCartProductQuantityOperation(admin, id));
        // }
      }
    }
  };

  const decrementQuantity = () => {
    if (clickDisabled || controlQuantity <= 1) return;

    setClickDisabled(true);
    const newQty = controlQuantity - 1;
    updateQuantityInCart(newQty);

    setTimeout(() => {
      setClickDisabled(false);
    }, 500);
  };

  const incrementQuantity = () => {
    if (clickDisabled || controlQuantity >= maxQuantity) return;

    setClickDisabled(true);
    const newQty = controlQuantity + 1;
    updateQuantityInCart(newQty);

    setTimeout(() => {
      setClickDisabled(false);
    }, 500);
  };

  const deleteProduct = () => {
    dispatch(changeLocalCartOperation(id, 'delete'));
    // if (isAuth) {
    //   dispatch(deleteProductFromCartOperation(admin, id, cart));
    // }
  };

  const calculatePrice = () => {
    let totalPrice = new Decimal(currentPrice).mul(controlQuantity); // множимо на кількість

    // Спочатку перевіряємо знижку категорії
    if (product.categories?.discount && isDiscountValid(product.categories.discount)) {
      const categoryDiscount = product.categories.discount;
      
      // Якщо є знижка на товарі (не 0), вона має пріоритет
      if (product.discount && product.discount > 0) {
        const discount = new Decimal(product.discount).div(100);
        totalPrice = totalPrice.mul(new Decimal(1).minus(discount));
      } else {
        // Інакше застосовуємо знижку категорії
        const discount = new Decimal(categoryDiscount.quantity).div(100);
        totalPrice = totalPrice.mul(new Decimal(1).minus(discount));
      }
    } 
    // Якщо немає дійсної знижки категорії, перевіряємо знижку товару
    else if (product.discount && product.discount > 0) {
      const discount = new Decimal(product.discount).div(100);
      totalPrice = totalPrice.mul(new Decimal(1).minus(discount));
    } else if (product.categories?.discount?.quantity > 0) {
      const categoryDiscount = product.categories.discount;
      const isActive = categoryDiscount.active === true;
      const isDateValid = new Date(categoryDiscount.dateEnd) >= new Date();
      
      if (isActive && isDateValid) {
        const discount = new Decimal(categoryDiscount.quantity).div(100);
        totalPrice = totalPrice.mul(new Decimal(1).minus(discount));
      }
    }

    return totalPrice.toDecimalPlaces(2).toString();
  };

  const getDiscountInfo = () => {
    // Спочатку перевіряємо знижку категорії
    if (product.categories?.discount && isDiscountValid(product.categories.discount)) {
      const categoryDiscount = product.categories.discount;
      
      // Якщо є знижка на товарі (не 0), вона має пріоритет
      if (product.discount && product.discount > 0) {
        return {
          name: "Знижка на товар",
          percentage: product.discount,
          amount: new Decimal(currentPrice).mul(controlQuantity).mul(product.discount).div(100).toDecimalPlaces(2).toString()
        };
      }
      
      // Інакше повертаємо знижку категорії
      return {
        name: categoryDiscount.name,
        percentage: categoryDiscount.quantity,
        amount: new Decimal(currentPrice).mul(controlQuantity).mul(categoryDiscount.quantity).div(100).toDecimalPlaces(2).toString()
      };
    }
    
    // Якщо немає дійсної знижки категорії, перевіряємо знижку товару
    if (product.discount && product.discount > 0) {
      return {
        name: "Знижка на товар",
        percentage: product.discount,
        amount: new Decimal(currentPrice).mul(controlQuantity).mul(product.discount).div(100).toDecimalPlaces(2).toString()
      };
    }
    
    return null;
  };

  const discountInfo = getDiscountInfo();

  // Функція для розрахунку повної ціни без знижки
  const calculateFullPrice = () => {
    return new Decimal(currentPrice).mul(controlQuantity).toDecimalPlaces(2).toString();
  };

  // Перевіряємо, чи є знижка
  const hasDiscount = () => {
    return discountInfo !== null;
  };

  const closeCart = () => {
    dispatch(saveModalOrderAction(false));
  };

  const decrementDisabled = controlQuantity <= 1;
  const incrementDisabled = controlQuantity >= maxQuantity;

  const BottleCost = ({ bottleCost }) => (
    <div>
      <hr />
      {bottleCost.bottles.map(item => {
        const count = Number.isInteger(item.count) ? item.count : Math.ceil(item.count);
        return (
          <div className={styles.bottleCost} key={item.bottleSize}>
            <strong>
              Флакон {item.bottleSize} мл / {count} шт:{' '}
            </strong>
            <strong>{item.price * count} грн</strong>
          </div>
        );
      })}
    </div>
  );

  return (
    <li className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.itemWrapper_name}>
          <div className={styles.delete}>
            {!disableDel && (
              <span
                onClick={() => {
                  deleteProduct();
                }}
                className={styles.deleteBtn}
              >
                &#128465;
              </span>
            )}
          </div>
          <NavLink to={`/products/item/${product._id}`} onClick={closeCart} className={styles.linkImg}>
            <img
              src={product.imageFirst ? product.imageFirst : `${defaultImg}`}
              className={styles.image}
              width={78}
              height={78}
              alt="product img"
            />
          </NavLink>
          <div className={styles.nameBlock}>
            <NavLink to={`/products/item/${product._id}`} onClick={closeCart}>
              <h4 className={styles.name}>{product.name}</h4>
            </NavLink>
            <PriceBlock
              previousPrice={previousPrice}
              currentPrice={currentPrice}
              product={product}
            />
          </div>
        </div>

        <div className={styles.itemWrapper_count}>
          <div>
            <div className={styles.quantityBlock}>
              <button
                disabled={decrementDisabled}
                className={styles.quantityBtn}
                type="button"
                onClick={decrementQuantity}
              >
                -
              </button>

              <input className={styles.quantityInput} type="text" value={controlQuantity} readOnly />
              <span>{product.bottling ? ' мл' : ' '}</span>
              <button
                disabled={incrementDisabled}
                className={styles.quantityBtn}
                type="button"
                onClick={incrementQuantity}
              >
                +
              </button>

              
            </div>

            {controlQuantity >= (bottling ? quantityMl : quantity) && (
              <span className={styles.ended}>
                В наявності є тільки ({bottling ? quantityMl : quantity} {bottling ? 'мл' : 'шт'})
              </span>
            )}
          </div>
          <div className={styles.price}>
            {hasDiscount() ? (
              <div className={styles.priceWithDiscount}>
                <div className={styles.currentTotalPrice}>{calculatePrice()} грн</div>
                <div className={styles.previousTotalPrice}>{replace(calculateFullPrice())} грн</div>
              </div>
            ) : (
              <span className={styles.regularTotalPrice}>{calculatePrice()} грн</span>
            )}
          </div>
        </div>
      </div>

      {product.bottling && bottleCost && <BottleCost bottleCost={bottleCost} />}
    </li>
  );
};

CartItem.propTypes = {
  product: PropTypes.object.isRequired,
  cartQuantity: PropTypes.number.isRequired,
  cart: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  disableDel: PropTypes.bool,
  bottleCost: PropTypes.object,
};

CartItem.defaultProps = {
  cart: [],
  disableDel: false,
  bottleCost: null,
};

export default CartItem;
